import { render } from "./App.vue?vue&type=template&id=0472422f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0472422f&lang=css"

import exportComponent from "C:\\Users\\grntm\\OneDrive\\Study\\Vue Mastery\\real-world-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__